module.exports = __webpack_public_path__ + "static/media/female2.fc83be11.png";


//////////////////
// WEBPACK FOOTER
// ./src/modules/assets/body-model/female2.png
// module id = 899
// module chunks = 0